<template>
	<div
		v-if="setup.organizationUser.id"
		class="organization-user-aside-details">
		<div
			class="organization-user-aside-details__header">
			<o-avatar
				class="organization-user-aside-details__avatar"
				root-url="/app/avatar/"
				:avatar="setup.organizationUser.avatarUrl"
				:name="setup.organizationUser.name"/>
			<div class="organization-user-aside-details__header-title">
				<p class="organization-user-aside-details__header-description">Détail du profil</p>
				<p class="organization-user-aside-details__header-name">{{ setup.organizationUser.name }}</p>
			</div>
		</div>

		<o-section>
			<shared-details-list-item
				legend="Nom Prénom"
				:value="setup.organizationUser.name"/>
			<shared-details-list-item legend="Adresse Email">
				<span class="text--info">{{ setup.organizationUser.authLogin }}</span>
			</shared-details-list-item>
			<shared-details-list-item
				legend="Date de création"
				:value="setup.organizationUser.userCreationDate?.toReadable()"/>
			<shared-details-list-item
				v-if="setup.self.suiteUserId"
				:value="setup.isOrganizationUserEntity() && setup.organizationUser.hasAccessToArmado ? 'Oui' : 'Non'"
				legend="Accès Armado"/>
			<shared-details-list-item
				v-if="setup.self.suiteUserId && setup.suiteUserId"
				legend="Statut sur la SUITE"
				:value="setup.isOrganizationUserEntity() && setup.organizationUser.isEnabledForSuite ? 'Activé' : 'Désactivé'"/>
		</o-section>

		<o-section>
			<o-tabs v-model="setup.activeTab">
				<o-tab-pane
					label="Rôles/Permissions"
					name="permissions">
					<organization-user-roles
						:readonly="readonly"
						:user="setup.organizationUser"
						:user-is-agency-watching-client="setup.userIsAgencyWatchingClient"/>
				</o-tab-pane>
				<o-tab-pane
					label="Sociétés"
					name="companies">
					<organization-user-companies
						:readonly="readonly"
						:user="setup.organizationUser"
						:user-is-agency-watching-client="setup.userIsAgencyWatchingClient"/>
				</o-tab-pane>
			</o-tabs>
		</o-section>
		<teleport
			v-if="_aside && setup.suiteUserId"
			:to="_aside?.slotActions">
			<o-button
				v-if="setup.dataLoaded"
				v-tooltip="`Gérer l'utilisateur sur la SUITE`"
				suffix-font-icon="icon-mon-espace"
				@click="setup.goToSuiteUser()"/>
		</teleport>
	</div>

	<o-loader
		:visible="!setup.dataLoaded &&!fake"
		message="Chargement des données..."/>
</template>

<script setup lang="ts">
import OrganizationUserRoles from './OrganizationUserRoles.vue';
import OrganizationUserCompanies from './OrganizationUserCompanies.vue';
import OrganizationUserAsideDetailsSetupService from '@/setup/organization-user/OrganizationUserAsideDetailsSetupService';
import { inject } from 'vue';
const _aside = inject<OrionAside>('_aside');
const props = defineProps(OrganizationUserAsideDetailsSetupService.props);
const setup = new OrganizationUserAsideDetailsSetupService(props, _aside);
</script>

<style scoped lang="less">
@import '@/styles/variables.less';

.organization-user-aside-details {
  &__header {
    display: flex;
    align-items: center;
    gap: 2rem;
    margin-bottom: 2.5rem;
  }

  &__header-title {
    p {
      margin: unset;
    }
  }

  &__header-description {
    font-size: 1rem;
    font-weight: 300;
    color: var(--grey-dark);
  }

  &__header-name {
    font-size: 2rem;
    line-height: 2rem;
    font-weight: 100;
    color: var(--grey-darker);
  }
}
</style>
